import React from 'react'
import {
  FormattedMessage,
} from 'react-intl'
import NavigationBar from '../../partials/NavigationBar'
import Footer from '../../partials/Footer'
import {
  DivAccount,
  AuthCard,
  Subtitle,
  Title,
  LabelEnd,
  ButtonWhite,
} from './styledComponents'

const End = function End (props) {
  const { onPrevious } = props

  return (
    <DivAccount>
      <NavigationBar
        centerText='Altrac'
      />
      <AuthCard>

        <Title>
          <FormattedMessage
            id='auth.end.created'
            defaultMessage='Altrac Account Created!'
            description='Altrac Account Created! label'
          />
        </Title>
        <Subtitle>
          <FormattedMessage
            id='auth.end.workingWithYou'
            defaultMessage='We are looking forward to working with you'
            description='We are looking forward to working with you label'
          />
        </Subtitle>

        <LabelEnd>
          <FormattedMessage
            id='auth.end.bookmark'
            defaultMessage='How to Bookmark our Webapp'
            description='How to Bookmark our Webapp label'
          />
          <iframe
            className='youtube-player'
            type='text/html'
            width='300'
            height='450'
            title='How to Bookmark our Webapp'
            src='https://www.youtube.com/embed/RgN1vzK5dX4?version=2&amp;rel=1&amp;fs=1&amp;autohide=2&amp;showsearch=0&amp;showinfo=1&amp;iv_load_policy=1&amp;wmode=transparent'
            allowFullScreen
            style={{ border: 0 }}
          />
        </LabelEnd>

        <ButtonWhite onClick={props.goToLogin}>
          <FormattedMessage
            id='landing.login'
            defaultMessage='LOGIN'
            description='LOGIN label'
          />
        </ButtonWhite>
      </AuthCard>
      <Footer />
    </DivAccount>
  )
}

export default End
